import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  isApplicantSelector,
  isCorpClientSelector,
  isEYProSelector,
  isEYAdminSelector,
  isCorporateClientLineManagerSelector,
} from 'src/ui/features/Login/state/loginReselect';
import GlobalMenuPres from './GlobalMenuPres';

const blurActiveElement = () => {
  if (typeof document === 'undefined') return;

  const { activeElement } = document;
  if (activeElement && typeof activeElement.blur === 'function') activeElement.blur();
};

class GlobalMenuContainer extends Component {
  static propTypes = {
    isApplicant: PropTypes.bool.isRequired,
    isEYAdmin: PropTypes.bool.isRequired,
    isEYPro: PropTypes.bool.isRequired,
  };

  state = {
    isMenuOpen: false,
  };

  toggleDrawer = open => () => {
    if (!open) blurActiveElement();
    this.setState({ isMenuOpen: open });
  };

  render() {
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
    const userRoles = userInfo && Array.isArray(userInfo.permissions) ? userInfo.permissions : [];
    const deleteUserRole = userRoles.some(role => role.roleName === 'DELETE_PROFILE');

    return (
      <GlobalMenuPres
        isEYPro={this.props.isEYPro}
        isEYAdmin={this.props.isEYAdmin}
        isApplicant={this.props.isApplicant}
        isMenuOpen={this.state.isMenuOpen}
        toggleDrawer={this.toggleDrawer}
        isDeleteProfile={deleteUserRole}
      />
    );
  }
}

// export default GlobalMenuContainer;
const mapStateToProps = state => {
  return {
    countInboxUnread: state.messaging.countInboxUnread,
    isEYPro: isEYProSelector(state),
    isEYAdmin: isEYAdminSelector(state),
    isApplicant: isApplicantSelector(state),
    isCorpClient: isCorpClientSelector(state),
    isCorporateClientLineManagerSelector: isCorporateClientLineManagerSelector(state),
  };
};

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GlobalMenuContainer);
